import React from 'react'
import { useTranslation } from 'react-i18next'

import { RightOfOccupancyFeePaid } from '../../../../../common/generated/residentApiSchemas'
import { FeeBreakdown } from '../FeeBreakdown/FeeBreakdown'
import { InfoNotification } from '../InfoNotification/InfoNotification'
import { PaidFee } from '../PaidFee/PaidFee'

export const PaidRightOfOccupancyFee: React.FC<{
  fee: RightOfOccupancyFeePaid
}> = ({ fee }) => {
  const { t } = useTranslation(['payments'])

  return (
    <>
      <InfoNotification
        text={t('payments:rightOfOccupancyFee.preliminaryNotice')}
      />
      <FeeBreakdown
        breakdown={fee.currentValue}
        title={t('payments:rightOfOccupancyFee.currentValueTitle')}
        indexInfoKey="payments:rightOfOccupancyFee.currentValueIndexInfo"
        totalLabel={t('payments:rightOfOccupancyFee.currentValue')}
      />
      <PaidFee paidAmount={fee.paidAmount} paidDate={fee.paidDate} />
    </>
  )
}
